$(window).on('load', function () {
	let $preloader = $('#page-preloader');
	$preloader.delay(700).fadeOut();
});

